// extracted by mini-css-extract-plugin
module.exports = {"modalBtns":"MainModal_modalBtns__1xtap","LogInBtn":"MainModal_LogInBtn__YimME","SignupBtn":"MainModal_SignupBtn__jiwKu"};